export { default as NavLink } from "./component";
